export enum ESearchFilter {
    ALL = 'ALL',
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
}

export enum ESearchBy {
    INFO = 'INFO',
    CPT = 'CPT',
    INSTITUTIOIN = 'INSTITUTION',
    PROCEDURE = 'PROCEDURE',
    KEYWORD = 'KEYWORD',
}